import React from 'react';
import R from 'ramda';
import TextBlock from './text-dff';
import PolicyMain from '../../../contracting/contract-activities-products/contract-policies/policies/policy-main';
import { getClassesForType2 } from './ratePackage-elements';

export const LocPolicyDiff = ({ diff, isLeft, originalData, policyType }) => {
  const classes = getClassesForType2(isLeft, diff, originalData, policyType, []);
  const data = originalData[isLeft ? 'lhs' : 'rhs'];
  return (
    <PolicyMain
      policyType={policyType}
      policyProps={{
        hideLabel: true,
        classes,
        [`${policyType}Info`]: {
          ...data,
        }
      }}
    />
  );
};
const setIn = (path, value, obj) => {
  const lensPath = R.lensPath(path);
  return R.set(lensPath, value, obj);
};
import { InsuranceInfoDisplay } from '../../../contracting/contract-activities-products/contract-policies/billing-info-node';
export const InsuranceDiff = ({ diff, isLeft, originalData }) => {
  const classes = getClassesForType2(isLeft, diff, originalData, 'insurance', ['insuranceFiles']);
  const data = originalData[isLeft ? 'lhs' : 'rhs'];
  return (
    <InsuranceInfoDisplay
      hideLabel
      {...data}
      classes={classes}
    />
  );
};

import { BillingInfoDisplay } from '../../../contracting/contract-activities-products/contract-policies/billing-info-node';
export const BillingDiff = ({ diff, isLeft, originalData }) => {
  const classes = getClassesForType2(isLeft, diff, originalData, 'billing', []);
  const data = originalData[isLeft ? 'lhs' : 'rhs'];
  return (
    <BillingInfoDisplay
      hideLabel
      {...data}
      classes={classes}
    />
  );
};

import CheckInCheckOut from '../../../contracting/contract-activities-products/contract-policies/checkinout';
export const CheckInCheckOutDiff = ({ diff, isLeft, originalData }) => {
  const classes = getClassesForType2(isLeft, diff, originalData, 'checkInCheckOut', []);
  const data = originalData[isLeft ? 'lhs' : 'rhs'];
  return (
    <CheckInCheckOut
      inDiffing
      {...data}
      classes={classes}
    />
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/policyNotes-elements.jsx